import React from 'react';
import PropTypes, { any } from 'prop-types';

import BallType from '../text/BallType';

import styles from './eventRegForm.scss';

const DivisionCard = ({
    division,
    subTitle,
    description,
    divisionPrice,
    errorText,
}) => {
    return (
        <>
            <div className={`radio-button radio-button-xl noselect `}>
                <label htmlFor={`division${division.id}`} className={errorText && `error`}>
                    <div className="radio-button-label">
                        <div className="d-flex justify-content-between">
                            <div className={`w-75 text-break`}>
                                <div>{division.name}</div>
                                {!!division.ballType && <div className="radio-button-description fs12 text-bold"><BallType ballType={division.ballType} /></div>}
                                {subTitle && <div className="radio-button-description fs12 text-bold">{subTitle}</div>}
                            </div>
                            <div className="d-flex flex-col justify-content-between justify-content-center align-items-center ml-auto">
                                <div className="price text-right">
                                    {divisionPrice()}
                                </div>
                            </div>
                        </div>
                        <div className="radio-button-description">{description}</div>
                    </div>
                </label>
            </div>
            {errorText && (
                <div className={`text-small text-error mt-12 mb16 ${styles.termAndConditions}`}>{errorText}</div>
            )}
        </>
    );
};

DivisionCard.propTypes = {
    division: PropTypes.objectOf(any).isRequired,
    subTitle: PropTypes.string,
    description: PropTypes.string,
    divisionPrice: PropTypes.number,
    errorText: PropTypes.string,
};

DivisionCard.defaultProps = {
    subTitle: '',
    description: '',
    divisionPrice: 0,
    errorText: '',
};

export default DivisionCard;
